import { openBlock, createElementBlock, normalizeClass, Fragment, createElementVNode, resolveComponent, renderList, createVNode, createCommentVNode, toDisplayString, resolveDirective, withDirectives, renderSlot, normalizeStyle, withKeys, vModelText, createBlock, withCtx, createTextVNode } from 'vue';
import vClickOutside from 'click-outside-vue3';

var script$g = {
  props: {
    isMultiple: {
      type: Boolean,
      default: false
    },
    indexCircle: {
      type: Number,
      default: 1
    }
  }
};

const _hoisted_1$d = /*#__PURE__*/createElementVNode("div", {
  class: "preloader__circle circle-1"
}, null, -1);
const _hoisted_2$a = /*#__PURE__*/createElementVNode("div", {
  class: "preloader__circle circle-2"
}, null, -1);
const _hoisted_3$7 = /*#__PURE__*/createElementVNode("div", {
  class: "preloader__circle circle-3"
}, null, -1);
function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(['preloader', {
      'preloader--is-multiple': $props.isMultiple
    }])
  }, [$props.isMultiple ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [_hoisted_1$d, _hoisted_2$a, _hoisted_3$7], 64)) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(['preloader__circle', `circle-${$props.indexCircle}`])
  }, null, 2))], 2);
}

script$g.render = render$e;

var script$f = {
  components: {
    MoPreloader: script$g
  },
  props: {
    codeLength: {
      type: Number,
      default: 4
    },
    errorMessage: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['sendHasBeenFocused', 'setCode'],
  data() {
    return {
      code: []
    };
  },
  mounted() {
    this.nodeElements = document.querySelectorAll('.code-group__input-container input');
  },
  methods: {
    setCode() {
      if (!(this.code.length === this.codeLength)) {
        return;
      }
      this.$emit('setCode', this.code.join(''));
    },
    onInput(index, event) {
      event.stopPropagation();
      if (!event.target.value) {
        return;
      }
      this.code[index] = event.target.value;
      this.focusNextOrBlurCurrent(event);
    },
    // Запрет ввода символов, кроме цифр
    onKeypress(e) {
      e.stopPropagation();
      const keyCode = e.which || e.keyCode;
      if (!(this.isNumberKeyCode(keyCode) || this.isTab(keyCode) || this.isBackspace(keyCode) || this.isMetaKey(e, keyCode))) {
        e.preventDefault();
      }
    },
    // Переход между input'ами
    onKeydown(event) {
      event.stopPropagation();
      const {
        parentElement
      } = event.target;
      const keyCode = event.which || event.keyCode;
      let sibling;
      if (this.isBackspace(keyCode)) {
        sibling = parentElement.previousElementSibling;
        if (sibling) {
          parentElement.firstElementChild.value = '';
          sibling.firstElementChild.focus();
        }
      } else if (this.isLeftArrow(keyCode) || this.isRightArrow(keyCode)) {
        if (this.isLeftArrow(keyCode)) {
          sibling = parentElement.previousElementSibling;
        } else {
          sibling = parentElement.nextElementSibling;
        }
        if (sibling && sibling.firstElementChild) {
          sibling.firstElementChild.focus();
        }
      }
    },
    onPaste(index, e) {
      e.preventDefault();
      let pasteData = (e.clipboardData || window.clipboardData).getData('text');
      pasteData = pasteData.replace(/\s/g, '').substr(0, this.codeLength - index).split('');
      this.pasteData(index, pasteData);
    },
    pasteData(index, pasteData) {
      for (let i = 0; i < this.nodeElements.length; i += 1) {
        const numericValue = Number(pasteData[i]);
        if (Number.isNaN(numericValue)) {
          return;
        }
        this.nodeElements[i + index].value = pasteData[i];
        this.code[i + index] = pasteData[i];
      }
      if (pasteData.length + index < this.codeLength) {
        this.nodeElements[pasteData.length].focus();
      } else {
        this.nodeElements[index].blur();
      }
    },
    focusNextOrBlurCurrent(e) {
      const {
        parentElement
      } = e.target;
      const {
        nextElementSibling
      } = parentElement;
      if (nextElementSibling && nextElementSibling.firstElementChild) {
        nextElementSibling.firstElementChild.focus();
      } else {
        parentElement.firstElementChild.blur();
      }
    },
    isNumberKeyCode(keyCode) {
      return keyCode >= 48 && keyCode <= 57;
    },
    isTab(keyCode) {
      return keyCode === 9;
    },
    isBackspace(keyCode) {
      return keyCode === 8;
    },
    isMetaKey(e, keyCode) {
      return e.metaKey && keyCode === 118;
    },
    isLeftArrow(keyCode) {
      return keyCode === 37;
    },
    isRightArrow(keyCode) {
      return keyCode === 39;
    }
  }
};

const _hoisted_1$c = {
  class: "code-group__inputs"
};
const _hoisted_2$9 = ["onInput", "onPaste"];
const _hoisted_3$6 = {
  key: 0,
  class: "code-group__preloader"
};
const _hoisted_4$5 = {
  key: 0,
  class: "code-group__error-text"
};
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoPreloader = resolveComponent("MoPreloader");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(['code-group', {
      'code-group--error': $props.errorMessage
    }])
  }, [createElementVNode("div", _hoisted_1$c, [(openBlock(true), createElementBlock(Fragment, null, renderList(Array($props.codeLength), (item, index) => {
    return openBlock(), createElementBlock("span", {
      key: index,
      class: normalizeClass(['code-group__input-wrapper', {
        'code-group__input-wrapper--loading': $props.isLoading
      }])
    }, [createElementVNode("input", {
      autocomplete: "off",
      type: "tel",
      maxlength: "1",
      onFocus: _cache[0] || (_cache[0] = $event => _ctx.$emit('sendHasBeenFocused')),
      onFocusout: _cache[1] || (_cache[1] = (...args) => $options.setCode && $options.setCode(...args)),
      onInput: $event => $options.onInput(index, $event),
      onKeydown: _cache[2] || (_cache[2] = (...args) => $options.onKeydown && $options.onKeydown(...args)),
      onKeypress: _cache[3] || (_cache[3] = (...args) => $options.onKeypress && $options.onKeypress(...args)),
      onPaste: $event => $options.onPaste(index, $event)
    }, null, 40, _hoisted_2$9), $props.isLoading ? (openBlock(), createElementBlock("div", _hoisted_3$6, [createVNode(_component_MoPreloader, {
      isMultiple: false,
      indexCircle: index
    }, null, 8, ["indexCircle"])])) : createCommentVNode("", true)], 2);
  }), 128))]), $props.errorMessage ? (openBlock(), createElementBlock("span", _hoisted_4$5, toDisplayString($props.errorMessage), 1)) : createCommentVNode("", true)], 2);
}

script$f.render = render$d;

var script$e = {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    items: {
      type: Array,
      default: () => [{
        id: 'RU',
        name: 'RU'
      }]
    },
    selectedItemId: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['select'],
  data() {
    return {
      isOpenMenu: false
    };
  },
  computed: {
    title() {
      if (this.selectedItemId) {
        return this.items.find(item => item.id === this.selectedItemId).name;
      } else {
        return this.items[0].name;
      }
    }
  },
  methods: {
    toggleMenu() {
      this.isOpenMenu = !this.isOpenMenu;
    },
    closeMenu() {
      this.isOpenMenu = false;
    },
    select(id) {
      this.isOpenMenu = false;
      this.$emit('select', id);
    }
  }
};

const _hoisted_1$b = {
  class: "select-field"
};
const _hoisted_2$8 = {
  class: "select-field__title"
};
const _hoisted_3$5 = {
  key: 0,
  class: "select-field__menu"
};
const _hoisted_4$4 = ["onClick"];
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createElementBlock("div", _hoisted_1$b, [withDirectives((openBlock(), createElementBlock("div", {
    class: "select-field__header",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleMenu && $options.toggleMenu(...args))
  }, [createElementVNode("div", _hoisted_2$8, toDisplayString($options.title), 1), createElementVNode("div", {
    class: normalizeClass({
      'select-field__arrow': true,
      'select-field__arrow--reversed': $data.isOpenMenu
    })
  }, null, 2)])), [[_directive_click_outside, $options.closeMenu]]), $data.isOpenMenu ? (openBlock(), createElementBlock("div", _hoisted_3$5, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.items, item => {
    return openBlock(), createElementBlock("div", {
      key: item,
      class: "select-field__menu-item",
      onClick: $event => $options.select(item.id)
    }, toDisplayString(item.name), 9, _hoisted_4$4);
  }), 128))])) : createCommentVNode("", true)]);
}

script$e.render = render$c;

const _hoisted_1$a = {
  class: "header-divider"
};
const _hoisted_2$7 = /*#__PURE__*/createElementVNode("hr", {
  class: "header-divider__line"
}, null, -1);
function render$b(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$a, [renderSlot(_ctx.$slots, "left-col"), _hoisted_2$7, renderSlot(_ctx.$slots, "right-col")]);
}

const script$c = {};
script$c.render = render$b;
var script$d = script$c;

var script$b = {
  props: {
    copyrightStartYear: {
      type: Number,
      default: new Date().getFullYear()
    },
    styleObject: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const currentYear = new Date().getFullYear();
    const isStartCurrentYear = currentYear === this.copyrightStartYear;
    return {
      copyrightYears: isStartCurrentYear ? currentYear : `${this.copyrightStartYear}-${currentYear}`
    };
  }
};

const _hoisted_1$9 = {
  class: "footer"
};
const _hoisted_2$6 = {
  class: "copyright"
};
const _hoisted_3$4 = /*#__PURE__*/createElementVNode("div", {
  class: "logo"
}, null, -1);
const _hoisted_4$3 = {
  key: 0,
  class: "payment-types-slot-wrapper"
};
const _hoisted_5$3 = {
  class: "footer-menu"
};
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$9, [createElementVNode("div", {
    class: "footer-cover",
    style: normalizeStyle($props.styleObject)
  }, [createElementVNode("div", _hoisted_2$6, toDisplayString($data.copyrightYears) + " © Все права защищены. ", 1), _hoisted_3$4, _ctx.$slots.paymentTypes ? (openBlock(), createElementBlock("div", _hoisted_4$3, [renderSlot(_ctx.$slots, "paymentTypes")])) : createCommentVNode("", true)], 4), createElementVNode("div", _hoisted_5$3, [renderSlot(_ctx.$slots, "default")])]);
}

script$b.render = render$a;

var script$a = {
  name: 'MoSearchField',
  props: {
    propSearchValue: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'search'],
  data() {
    return {
      searchValue: ''
    };
  },
  watch: {
    propSearchValue: {
      handler(value) {
        if (this.searchValue) {
          return;
        }
        this.searchValue = value;
      }
    }
  }
};

const _hoisted_1$8 = {
  class: "search-field"
};
const _hoisted_2$5 = {
  class: "search-field__input"
};
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$8, [createElementVNode("div", _hoisted_2$5, [withDirectives(createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchValue = $event),
    type: "text",
    placeholder: "Поиск",
    onKeyup: _cache[1] || (_cache[1] = withKeys($event => _ctx.$emit('search', $data.searchValue), ["enter"])),
    onInput: _cache[2] || (_cache[2] = $event => _ctx.$emit('input', $data.searchValue))
  }, null, 544), [[vModelText, $data.searchValue]]), createElementVNode("i", {
    class: "search-field__icon",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('search', $data.searchValue))
  })])]);
}

script$a.render = render$9;

var script$9 = {
  name: 'UserLogin',
  props: {
    avatarUrl: {
      type: String,
      required: true
    },
    isAuthorized: Boolean
  },
  emits: ['avatarClick', 'signIn']
};

const _hoisted_1$7 = {
  class: "user-login"
};
const _hoisted_2$4 = ["src"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [$props.isAuthorized ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "user-login__user-avatar",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('avatarClick'))
  }, [createElementVNode("img", {
    src: $props.avatarUrl
  }, null, 8, _hoisted_2$4)])) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: "user-login__auth-btn",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('signIn'))
  }, " Вход "))]);
}

script$9.render = render$8;

var script$8 = {
  props: {
    items: {
      type: Array,
      default: function () {
        return ['Обзор', 'Описание'];
      }
    }
  }
};

const _hoisted_1$6 = {
  class: "mo-breadcrumb"
};
const _hoisted_2$3 = /*#__PURE__*/createElementVNode("div", {
  class: "mo-breadcrumb__divider"
}, null, -1);
const _hoisted_3$3 = {
  class: "mo-breadcrumb__title"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$6, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.items, (item, index) => {
    return openBlock(), createElementBlock("div", {
      key: index,
      class: normalizeClass(["mo-breadcrumb__item", {
        'mo-breadcrumb__item--primary': index === 0
      }])
    }, [_hoisted_2$3, createElementVNode("div", _hoisted_3$3, toDisplayString(item), 1)], 2);
  }), 128))]);
}

script$8.render = render$7;

var script$7 = {
  props: {
    isActive: {
      default: false,
      type: Boolean
    },
    isDisabled: {
      default: false,
      type: Boolean
    }
  }
};

var _imports_0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAAAXNSR0IArs4c6QAAAE5JREFUGBlj6Gyf2MCABTD9/89Qj02SCaQYmyRYApskXAJdkgUkgAygxjKg6EBWgCHByMjQWF6Z34AiARME6YRLIAvCJdAFwXZh8zVIAgBMACR3NzRZcwAAAABJRU5ErkJggg==";

var _imports_1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAAAXNSR0IArs4c6QAAARBJREFUGBllUL1KA0EQntmIeilEey19iIjaCHKllZLKRrA7bw1ZzifwuMDtebWNVdDK8iCVSAw+gE+gD6CCMQbdcb+DgODADPP97DIznKZFTiJaEZ+as9jSn8jOC+1IcmK2LCKcpRd9YtpnRW1j4mt4s6w4EEd9EroxyUmbQZZluTAeu8qDlhIJwTnmSohGzaYKoyj6qo0QrLXL0wnfC8saMAs/CwebSXL8VmOUWfR6tvXzTQ/AjTna6Hb1aKb9+9HPulqLQi/zi7KltX4FViiYcTqhW29aZ6X2kOjBQauN2Przw135E2z7rQ+Nie6Q6MFBg6cRBCs5kRz5O3ZMEl/iNWIwqJ52d8J3IekMh49Lv8IccZa5CcaqAAAAAElFTkSuQmCC";

const _hoisted_1$5 = {
  key: 0,
  src: _imports_0,
  class: "mo-vertical-menu-subitem__arrow"
};
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({
      'mo-vertical-menu-subitem': true,
      'mo-vertical-menu-subitem--disabled': $props.isDisabled
    })
  }, [$props.isActive ? (openBlock(), createElementBlock("img", _hoisted_1$5)) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default"), $props.isActive ? (openBlock(), createElementBlock("img", {
    key: 1,
    src: _imports_1,
    class: "mo-vertical-menu-subitem__close",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
  })) : createCommentVNode("", true)], 2);
}

script$7.render = render$6;

var script$6 = {
  props: {
    isActive: {
      default: false,
      type: Boolean
    },
    isDisabled: {
      default: false,
      type: Boolean
    }
  }
};

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({
      'mo-vertical-menu-item': true,
      'mo-vertical-menu-item--disabled': $props.isDisabled,
      'mo-vertical-menu-item--active': $props.isActive
    })
  }, [renderSlot(_ctx.$slots, "default")], 2);
}

script$6.render = render$5;

const _hoisted_1$4 = {
  class: "mo-vertical-menu"
};
function render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [renderSlot(_ctx.$slots, "default")]);
}

const script$4 = {};
script$4.render = render$4;
var script$5 = script$4;

var IconTriangle = "data:image/svg+xml,%3Csvg%20width%3D%2246%22%20height%3D%2225%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22m23%200%2023%2025H0z%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";

var IconTriangleMini = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2212%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m12%200%2012%2012H0z%22%20fill%3D%22%23FFF%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";

const items = [{
  title: 'Виды блюд'
}, {
  title: 'Выбор кухни'
}, {
  title: 'Особенности'
}, {
  title: 'Акции'
}, {
  title: 'Предзаказ'
}, {
  title: 'Аксессуары'
}, {
  title: 'Аксессуары'
}, {
  title: 'Аксессуары'
}, {
  title: 'Аксессуары'
}];
const LIMITS = {
  smallMobile: {
    value: 1,
    max: 320
  },
  mediumMobile: {
    value: 2,
    min: 320,
    max: 480
  },
  largeMobile: {
    value: 4,
    min: 480,
    max: 768
  },
  smallDesktop: {
    value: 3,
    min: 768,
    max: 1024
  },
  mediumDesktop: {
    value: 5,
    min: 1024,
    max: 1200
  },
  largeDesktop: {
    value: 6,
    min: 1200,
    max: 1400
  },
  extralargeDesktop: {
    value: 8,
    min: 1400
  }
};
var script$3 = {
  props: {
    items: {
      type: Array,
      default: () => items
    },
    isMiniArrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      windowWidth: null
    };
  },
  computed: {
    categoriesLimit() {
      return this.getCategoriesLimitByBreakpoint();
    },
    mainCategoriesList() {
      if (this.categoriesLimit === -1) {
        return this.items;
      }
      return this.items.slice(0, this.categoriesLimit);
    },
    hiddenCategoriesList() {
      if (this.categoriesLimit === -1) {
        return [];
      }
      return this.items.slice(this.categoriesLimit);
    },
    image() {
      return this.isMiniArrow ? IconTriangleMini : IconTriangle;
    }
  },
  created() {
    window.addEventListener('resize', this.redrawLayout);
    this.redrawLayout();
  },
  destroyed() {
    window.removeEventListener('resize', this.redrawLayout);
  },
  methods: {
    redrawLayout() {
      this.windowWidth = window.innerWidth;
    },
    getCategoriesLimitByBreakpoint() {
      let result = -1;
      Object.keys(LIMITS).forEach(sizeName => {
        if (this.windowWidth > (LIMITS[sizeName].min || 0) && this.windowWidth <= (LIMITS[sizeName].max || this.windowWidth) && this.items.length > LIMITS[sizeName].value) {
          result = LIMITS[sizeName].value;
        }
      });
      return result;
    }
  }
};

const _hoisted_1$3 = {
  class: "mo-main-menu"
};
const _hoisted_2$2 = ["onClick"];
const _hoisted_3$2 = ["src"];
const _hoisted_4$2 = {
  key: 0,
  class: "mo-main-menu__item submenu"
};
const _hoisted_5$2 = {
  class: "submenu__title"
};
const _hoisted_6$1 = /*#__PURE__*/createElementVNode("div", {
  class: "submenu__title-text"
}, "Еще", -1);
const _hoisted_7$1 = {
  id: "submenu",
  class: "submenu__dropdown"
};
const _hoisted_8$1 = ["onClick"];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = resolveComponent("router-link");
  return openBlock(), createElementBlock("div", _hoisted_1$3, [(openBlock(true), createElementBlock(Fragment, null, renderList($options.mainCategoriesList, item => {
    return openBlock(), createElementBlock("div", {
      key: item,
      class: normalizeClass({
        'mo-main-menu__item': true,
        'mo-main-menu__item--active': item.isActive
      })
    }, [item.routeSettings || item.route ? (openBlock(), createBlock(_component_router_link, {
      key: 0,
      to: item.routeSettings || {
        name: item.route
      },
      class: "mo-main-menu__link"
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(item.title), 1)]),
      _: 2
    }, 1032, ["to"])) : (openBlock(), createElementBlock("div", {
      key: 1,
      onClick: $event => _ctx.$emit(item.action || 'click', item)
    }, toDisplayString(item.title || item), 9, _hoisted_2$2)), createElementVNode("img", {
      src: $options.image,
      class: normalizeClass({
        'arrow-icon': true,
        'arrow-icon--mini': $props.isMiniArrow
      })
    }, null, 10, _hoisted_3$2)], 2);
  }), 128)), $options.hiddenCategoriesList.length ? (openBlock(), createElementBlock("div", _hoisted_4$2, [createElementVNode("div", _hoisted_5$2, [_hoisted_6$1, createElementVNode("div", _hoisted_7$1, [(openBlock(true), createElementBlock(Fragment, null, renderList($options.hiddenCategoriesList, item => {
    return openBlock(), createElementBlock("div", {
      key: item,
      class: "submenu__list-item"
    }, [item.routeSettings || item.route ? (openBlock(), createBlock(_component_router_link, {
      key: 0,
      to: item.routeSettings || {
        name: item.route
      },
      class: "mo-main-menu__link"
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(item.title), 1)]),
      _: 2
    }, 1032, ["to"])) : (openBlock(), createElementBlock("div", {
      key: 1,
      onClick: $event => _ctx.$emit(item.action || 'click', item)
    }, toDisplayString(item.title || item), 9, _hoisted_8$1))]);
  }), 128))])])])) : createCommentVNode("", true)]);
}

script$3.render = render$3;

var script$2 = {
  name: 'MoPanel'
};

const _hoisted_1$2 = {
  class: "mo-panel"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [renderSlot(_ctx.$slots, "default")]);
}

script$2.render = render$2;

const buttonColorOptions = {
  green: 'green',
  blue: 'blue',
  gray: 'gray',
  red: 'red',
  'dark-gray': 'dark-gray'
};
const buttonTypesOptions = {
  default: 'default',
  large: 'large'
};

var script$1 = {
  name: 'MoSpinner'
};

const _hoisted_1$1 = {
  class: "mo-spinner"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("div", {
  class: "mo-spinner__child mo-spinner__child--bounce1"
}, null, -1);
const _hoisted_3$1 = /*#__PURE__*/createElementVNode("div", {
  class: "mo-spinner__child mo-spinner__child--bounce2"
}, null, -1);
const _hoisted_4$1 = /*#__PURE__*/createElementVNode("div", {
  class: "mo-spinner__child"
}, null, -1);
const _hoisted_5$1 = [_hoisted_2$1, _hoisted_3$1, _hoisted_4$1];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, _hoisted_5$1);
}

script$1.render = render$1;

var script = {
  name: 'MoPolygonButton',
  components: {
    MoSpinner: script$1
  },
  props: {
    title: {
      default: 'Сохранить',
      type: String
    },
    type: {
      default: buttonTypesOptions.default,
      type: String,
      validator: value => Object.keys(buttonTypesOptions).includes(value)
    },
    color: {
      type: String,
      default: buttonColorOptions.green,
      validator: value => Object.keys(buttonColorOptions).includes(value)
    },
    isDisabled: {
      default: false,
      type: Boolean
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isHover: false,
      [buttonColorOptions.green]: {
        default: ['#46B82C', '#269D1D', '#34AB2B', '#34AB2B'],
        hover: ['#61D746', '#34AB2B', '#46B82C', '#46B82C']
      },
      [buttonColorOptions.blue]: {
        default: ['#319BD4', '#227DB4', '#2889C0', '#2889C0'],
        hover: ['#59B8EB', '#227DB4', '#2889C0', '#2889C0']
      },
      [buttonColorOptions.gray]: {
        default: ['#E2E2E2', '#D1D1D1', '#D7D7D7', '#D7D7D7'],
        hover: ['#E2E2E2', '#D1D1D1', '#D7D7D7', '#D7D7D7']
      },
      [buttonColorOptions.red]: {
        default: ['#FE0000', '#DB0404', '#E90202', '#E90202'],
        hover: ['#FF5050', '#DB0404', '#E90202', '#E90202']
      },
      [buttonColorOptions['dark-gray']]: {
        default: ['#686465', '#454142', '#575352', '#575352'],
        hover: ['#858384', '#454142', '#575352', '#575352']
      }
    };
  },
  computed: {
    colors() {
      const type = this.isHover ? 'hover' : 'default';
      return this[this.color][type];
    }
  },
  methods: {
    mouseOver() {
      this.isHover = true;
    },
    mouseOut() {
      this.isHover = false;
    },
    click() {
      this.$emit('click');
    }
  }
};

const _hoisted_1 = {
  key: 0,
  class: "mo-polygon-button__background",
  width: "157px",
  height: "34px",
  viewBox: "0 0 157 34",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_3 = ["fill"];
const _hoisted_4 = ["fill"];
const _hoisted_5 = ["fill"];
const _hoisted_6 = ["fill"];
const _hoisted_7 = {
  key: 1,
  class: "mo-polygon-button__background",
  width: "273px",
  height: "34px",
  viewBox: "0 0 273 34",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_8 = {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_9 = ["fill"];
const _hoisted_10 = ["fill"];
const _hoisted_11 = ["fill"];
const _hoisted_12 = ["fill"];
const _hoisted_13 = {
  key: 2,
  class: "mo-polygon-button__spinner"
};
const _hoisted_14 = {
  key: 3,
  class: "mo-polygon-button__title"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoSpinner = resolveComponent("MoSpinner");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({
      'mo-polygon-button': true,
      'mo-polygon-button--disabled': $props.isDisabled,
      'mo-polygon-button--loading': $props.isLoading,
      [`mo-polygon-button--${$props.color}`]: true,
      [`mo-polygon-button--${$props.type}`]: true
    }),
    onMouseover: _cache[0] || (_cache[0] = (...args) => $options.mouseOver && $options.mouseOver(...args)),
    onMouseout: _cache[1] || (_cache[1] = (...args) => $options.mouseOut && $options.mouseOut(...args)),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.click && $options.click(...args))
  }, [$props.type === 'default' ? (openBlock(), createElementBlock("svg", _hoisted_1, [createElementVNode("g", _hoisted_2, [createElementVNode("polygon", {
    fill: $options.colors[0],
    "fill-rule": "nonzero",
    points: "4 5 27 0 130 0 157 5 152 28 135 34 21 34 0 27"
  }, null, 8, _hoisted_3), createElementVNode("polygon", {
    fill: $options.colors[1],
    "fill-rule": "nonzero",
    points: "108 14 157 5 152 28 135 34 21 34"
  }, null, 8, _hoisted_4), createElementVNode("polygon", {
    fill: $options.colors[2],
    "fill-rule": "nonzero",
    points: "108 14 135 34 21 34"
  }, null, 8, _hoisted_5), createElementVNode("polygon", {
    fill: $options.colors[3],
    "fill-rule": "nonzero",
    points: "108 14 157 5 152 28"
  }, null, 8, _hoisted_6)])])) : createCommentVNode("", true), $props.type === 'large' ? (openBlock(), createElementBlock("svg", _hoisted_7, [createElementVNode("g", _hoisted_8, [createElementVNode("polygon", {
    fill: $options.colors[0],
    "fill-rule": "nonzero",
    points: "4 5 27 -1.0658141e-14 245.429355 -1.0658141e-14 272.429355 5\n                                  267.429355 28 250.429355 34 21 34 5.68434189e-14 27"
  }, null, 8, _hoisted_9), createElementVNode("polygon", {
    fill: $options.colors[1],
    "fill-rule": "nonzero",
    points: "223 14 272 5 267 28 250 34 136 34"
  }, null, 8, _hoisted_10), createElementVNode("polygon", {
    fill: $options.colors[2],
    "fill-rule": "nonzero",
    points: "223 14 250 34 136 34"
  }, null, 8, _hoisted_11), createElementVNode("polygon", {
    fill: $options.colors[3],
    "fill-rule": "nonzero",
    points: "223 14 272 5 267 28"
  }, null, 8, _hoisted_12)])])) : createCommentVNode("", true), $props.isLoading ? (openBlock(), createElementBlock("div", _hoisted_13, [createVNode(_component_MoSpinner)])) : (openBlock(), createElementBlock("span", _hoisted_14, toDisplayString($props.title), 1))], 34);
}

script.render = render;

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MoPreloader: script$g,
    MoCodeField: script$f,
    MoSelectField: script$e,
    MoHeaderDivider: script$d,
    MoFooter: script$b,
    MoSearchField: script$a,
    MoUserLogin: script$9,
    MoBreadcrumb: script$8,
    MoVerticalMenuSubitem: script$7,
    MoVerticalMenuItem: script$6,
    MoVerticalMenu: script$5,
    MoMainMenu: script$3,
    MoPanel: script$2,
    MoPolygonButton: script,
    MoSpinner: script$1
});

// Import vue components

// install function executed by Vue.use()
const install = function installMo(Vue) {
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
};

export { script$8 as MoBreadcrumb, script$f as MoCodeField, script$b as MoFooter, script$d as MoHeaderDivider, script$3 as MoMainMenu, script$2 as MoPanel, script as MoPolygonButton, script$g as MoPreloader, script$a as MoSearchField, script$e as MoSelectField, script$1 as MoSpinner, script$9 as MoUserLogin, script$5 as MoVerticalMenu, script$6 as MoVerticalMenuItem, script$7 as MoVerticalMenuSubitem, install as default };
